import { IUserInfoModel } from '../../auth/types'
import { IMfeManifest, IMfeMenu, MfeRouteGroup, VisibleMfeRouteGroup } from '../types'

const MENU_NAMES = new Map<VisibleMfeRouteGroup, string>([
  [MfeRouteGroup.Freights, 'Cargas'],
  [MfeRouteGroup.Financial, 'Financeiro'],
  [MfeRouteGroup.Register, 'Cadastros'],
  [MfeRouteGroup.Cockpit, 'Cockpit'],
  [MfeRouteGroup.Dochub, 'Documentos']
])

export const loadMenus = (
  manifests: IMfeManifest[],
  userInfo: IUserInfoModel | null,
): Array<IMfeMenu> => {
  if (!userInfo?.hasRoles) return []

  const menus: Array<IMfeMenu> = Array.from(MENU_NAMES.entries()).map(([routeGroup, name]) => ({
    name,
    routeGroup,
    items: [],
  }))

  const availableMfes = manifests.filter((manifest) => manifest.loaded)

  for (const mfe of availableMfes) {
    for (const [index, route] of mfe.routes.entries()) {
      const menu = menus.find((menu) => menu.routeGroup === route.group)

      if (menu === undefined) continue

      const userHasAccessToRoute: boolean =
        route.acceptedRoles.length === 0 ||
        route.acceptedRoles.some((r) => userInfo.roles.includes(r))

      if (!userHasAccessToRoute) continue

      menu.items.push({
        id: index,
        label: route.label,
        path: `/${mfe.basePath}/${route.path}`,
        target: route.target,
      })
    }
  }

  return menus.filter((m) => m.items.length > 0)
}
